import { create } from 'zustand';

import type { Breakpoint } from './schema.types';

/**
 * Transient, UI-only "active editing breakpoint" — shared between the property
 * panel's breakpoint selector and the canvas/preview frame. `null` = the
 * desktop base layout. Kept out of the editor (document) store so it never
 * lands in undo history or sync.
 */
interface BreakpointState {
  breakpoint: Breakpoint | null;
  setBreakpoint(bp: Breakpoint | null): void;
}

export const useBreakpointStore = create<BreakpointState>((set) => ({
  breakpoint: null,
  setBreakpoint: (breakpoint) => set({ breakpoint }),
}));

/** The currently-active editing breakpoint (`null` = desktop base). */
export function useActiveBreakpoint(): Breakpoint | null {
  return useBreakpointStore((s) => s.breakpoint);
}

export function useSetBreakpoint(): (bp: Breakpoint | null) => void {
  return useBreakpointStore((s) => s.setBreakpoint);
}
